import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import CryptoJS from 'crypto-js';
import { updatePassWord } from '@/api/personalApi.js';
import { logout } from '@/services/user';
export default {
  data: function data() {
    var _this = this;
    var checkPending;
    var checkAge = function checkAge(rule, value, callback) {
      // clearTimeout(checkPending);
      if (value === '') {
        return callback(new Error('请输入正确的密码'));
      }
      checkPending = setTimeout(function () {
        if (value.toString().length < 6) {
          callback(new Error('密码长度最少六位'));
        } else {
          callback();
        }
      }, 1000);
    };
    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入正确的密码'));
      } else if (value.toString().length < 6) {
        callback(new Error('密码长度最少六位！'));
      } else {
        callback();
      }
    };
    var validatePass2 = function validatePass2(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入正确的密码'));
      } else if (value !== _this.ruleForm.pass) {
        callback(new Error('两次密码不一致'));
      } else {
        callback();
      }
    };
    return {
      isDev: true,
      labelCol: {
        span: 7
      },
      wrapperCol: {
        span: 15
      },
      ruleForm: {
        pass: '',
        checkPass: '',
        oldPassword: ''
      },
      rules: {
        pass: [{
          validator: validatePass,
          trigger: 'change'
        }],
        checkPass: [{
          validator: validatePass2,
          trigger: 'change'
        }],
        oldPassword: [{
          validator: checkAge,
          trigger: 'change'
        }]
      }
    };
  },
  methods: {
    encryption: function encryption(pas) {
      var key = CryptoJS.enc.Utf8.parse('MYYC-Hyd20220601'); //秘钥
      var srcs = CryptoJS.enc.Utf8.parse(pas);
      var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var userInfo = localStorage.getItem('admin.user');
          var mobile = JSON.parse(userInfo).mobile;
          var parma = {
            mobile: mobile,
            oldPassWord: _this2.encryption(_this2.ruleForm.oldPassword),
            pass: _this2.encryption(_this2.ruleForm.pass)
          };
          updatePassWord(parma).then(function (res) {
            if (res.data.code == 200) {
              _this2.$message.success('密码修改成功，请重新登录！');
              setTimeout(function () {
                logout();
                _this2.$router.push('/login');
              }, 1000);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};